// extracted by mini-css-extract-plugin
export default {"primaryBox":"PrimaryBox_primaryBox__pAOGy","wide":"PrimaryBox_wide__J0U0M"};